/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 13:52:08
 * @FilePath: \qctsw-vue\packages\app\src\logic\news\author.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { contentRemoveTags, isClient } from '@qctsw/utils'
import { imageTransform } from '@qctsw/common'
import { LOAD_STATE } from '@/shared/types'
import type { AuthorDetailResponse, NewsColumnPageResponse } from '@/server/types'
import { getAuthorDetailApi, getNewsColumnPageApi } from '@/server'
import { useGetRouteParam, useGetRouteQuery } from '@/shared/function'
import type { PaginationFn } from '@/composables/usePagination'
import { usePagination } from '@/composables/usePagination'

export function logicAuthorDetail() {
  const id = useGetRouteParam('id', '')
  const page = useGetRouteQuery('page', '1')

  const state = ref(LOAD_STATE.INIT)
  const pageData = ref<NewsColumnPageResponse[]>([])
  const authorData = ref<AuthorDetailResponse | null>(null)
  const pagination = shallowRef<PaginationFn | null>(null)
  const { setShareBase } = useShare()

  async function getAuthorDetail() {
    try {
      const res = await useLoadState({
        key: `媒体详情`,
        state,
        fn: () => getAuthorDetailApi(id.value),
      })
      if (res?.data) {
        authorData.value = res.data

        pagination.value = usePagination({
          type: 'up',
          key: '媒体文章列表',
          request: params => getNewsColumnPageApi({ ...params, authorId: Number(id.value) }),
        })
        if (isClient) {
          // share
          setShareBase({
            url: window.location.href,
            title: `媒体-${authorData.value.authorName}`,
            content: '',
            images: [imageTransform(authorData.value.headImg, { width: 160, height: 160 })],
          })
        }
      }
    }
    catch {}
  }

  async function getAuthorArticleList(page: string | number = 1) {
    if (!pagination.value || Number.isNaN(Number(page)))
      return

    const { list } = await pagination.value.loadPaginationData(Number(page)) || {}

    if (!list)
      return
    pageData.value.push(...list)
  }

  useActivatedWatch(() => [
    watch(page, () => {
      getAuthorArticleList(page.value)
      window.scrollTo(0, 0)
    }),
  ])

  return {
    id,
    page,

    state,
    authorData,
    pageData,
    pagination,
    getAuthorDetail,
    getAuthorArticleList,
  }
}
